import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { LimitType } from 'types/limits';
import React from 'react';
import { IActionDialogProps } from 'types/common';
import { LimitsExceededDialog } from '@components/GeneralDialogs';

interface ICreateActionButton {
	Dialog: React.FC<IActionDialogProps>;
	buttonLabel: string;
	limitType?: LimitType;
	limitExceeded?: boolean;
}

const CreateActionButton: React.FC<ICreateActionButton> = ({
	Dialog,
	buttonLabel,
	limitExceeded,
	limitType
}) => {
	const [open, setOpen] = React.useState(false);

	const handleClick = React.useCallback(() => {
		setOpen(!open);
	}, [open, setOpen]);

	const handleCreate = React.useCallback(async () => {
		setOpen(false);
	}, [setOpen]);

	return (
		<>
			<Button
				variant="outlined"
				startIcon={<AddIcon />}
				size="small"
				data-testid="create-action-button"
				onClick={handleClick}
			>
				{buttonLabel}
			</Button>

			{open &&
				(limitType && limitExceeded ? (
					<LimitsExceededDialog limitType={limitType} onCancel={handleClick} />
				) : (
					<Dialog onCreate={handleCreate} onCancel={handleClick} />
				))}
		</>
	);
};

CreateActionButton.defaultProps = {
	limitType: undefined,
	limitExceeded: false
};

export default CreateActionButton;
